import {
  EmptyTasksType,
  SelectOneTask,
  TaskType,
  TestTask,
  TaskWithLinkType,
  TextTask,
  SentenceStructureTask,
  GapTask,
} from '../shared/types';
import {
  GapTaskTypes,
  MathFormulasTask,
  ExcludeTask,
  UnderlineTask,
  WordCompositionTask,
  WordStressTask,
} from '../shared/types/task';

export const emptyTextTask: TextTask = {
  id: '',
  text: '',
  subText: '',
  hasAnswer: true,
  completedAt: '',
  hasStar: false,
  isActive: true,
  createdAt: new Date().getTime(),
  type: TaskType.text,
  indexNumber: 0,
  hasPhoto: false,
};

export const emptyTaskWithLink: TaskWithLinkType = {
  id: '',
  text: '',
  subText: '',
  hasAnswer: true,
  completedAt: '',
  hasStar: false,
  isActive: true,
  createdAt: new Date().getTime(),
  type: TaskType.link,
  indexNumber: 0,
  url: '',
  hasPhoto: false,
};

export const emptyTestTask: TestTask = {
  id: '',
  text: '',
  subText: '',
  hasAnswer: true,
  completedAt: '',
  hasStar: false,
  isActive: true,
  createdAt: new Date().getTime(),
  type: TaskType.test,
  indexNumber: 0,
  hasPhoto: false,
  testItems: [],
};

export const emptyGapTask: GapTask = {
  id: '',
  text: '',
  subText: '',
  hasAnswer: true,
  completedAt: '',
  hasStar: false,
  isActive: true,
  createdAt: new Date().getTime(),
  type: TaskType.gap,
  indexNumber: 0,
  hasPhoto: false,
  sentence: '',
  gapWords: [],
  gapTaskType: GapTaskTypes.letters,
};

export const emptyMathFormulasTask: MathFormulasTask = {
  id: '',
  text: '',
  subText: '',
  hasAnswer: true,
  completedAt: '',
  hasStar: false,
  isActive: true,
  createdAt: new Date().getTime(),
  type: TaskType.mathFormulas,
  indexNumber: 0,
  hasPhoto: false,
  formula: '',
  formulas: [],
};

export const emptyWordCompositionTask: WordCompositionTask = {
  id: '',
  text: '',
  subText: '',
  hasAnswer: true,
  completedAt: '',
  hasStar: false,
  isActive: true,
  createdAt: new Date().getTime(),
  type: TaskType.wordComposition,
  indexNumber: 0,
  hasPhoto: false,
  words: [],
};

export const emptyWordStressTask: WordStressTask = {
  id: '',
  text: '',
  subText: '',
  hasAnswer: true,
  completedAt: '',
  hasStar: false,
  isActive: true,
  createdAt: new Date().getTime(),
  type: TaskType.wordStress,
  indexNumber: 0,
  hasPhoto: false,
  words: [],
};

export const emptyWordUnderlineTask: UnderlineTask = {
  id: '',
  text: '',
  subText: '',
  hasAnswer: true,
  completedAt: '',
  hasStar: false,
  isActive: true,
  createdAt: new Date().getTime(),
  type: TaskType.underline,
  indexNumber: 0,
  hasPhoto: false,
  words: [],
};

export const emptyExcludesTask: ExcludeTask = {
  id: '',
  text: '',
  hasAnswer: true,
  completedAt: '',
  hasStar: false,
  isActive: true,
  createdAt: new Date().getTime(),
  type: TaskType.exclude,
  indexNumber: 0,
  hasPhoto: false,
  options: [],
};

export const emptySelectOneTask: SelectOneTask = {
  id: '',
  text: '',
  hasAnswer: true,
  completedAt: '',
  hasStar: false,
  isActive: true,
  createdAt: new Date().getTime(),
  type: TaskType.selectOne,
  indexNumber: 0,
  hasPhoto: false,
  lines: [],
};

export const emptySentenceStructureTask: SentenceStructureTask = {
  id: '',
  text: '',
  hasAnswer: true,
  completedAt: '',
  hasStar: false,
  isActive: true,
  createdAt: new Date().getTime(),
  type: TaskType.sentenceStructure,
  indexNumber: 0,
  hasPhoto: false,
  sentence: '',
};

export const emptyTasks: EmptyTasksType = {
  text: emptyTextTask,
  link: emptyTaskWithLink,
  test: emptyTestTask,
  gap: emptyGapTask,
  exclude: emptyExcludesTask,
  selectOne: emptySelectOneTask,
  sentenceStructure: emptySentenceStructureTask,
  mathFormulas: emptyMathFormulasTask,
  wordComposition: emptyWordCompositionTask,
  wordStress: emptyWordStressTask,
  underline: emptyWordUnderlineTask,
};
